import { render, staticRenderFns } from "./addNewSingleShortLink.vue?vue&type=template&id=63bfefe6&scoped=true"
import script from "./addNewSingleShortLink.vue?vue&type=script&lang=js"
export * from "./addNewSingleShortLink.vue?vue&type=script&lang=js"
import style0 from "./addNewSingleShortLink.vue?vue&type=style&index=0&id=63bfefe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bfefe6",
  null
  
)

export default component.exports